module.exports = __webpack_public_path__ + "static/media/car.75cdf649.svg";